import { useState, useEffect } from 'react';
import { useAuthFetch } from '@/hooks/useAdmin';
import { Phone, Archive, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdInquiries() {
  const authFetch = useAuthFetch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  async function load() {
    try { const r = await authFetch(`${API}/admin/ad-inquiries`); if (r.ok) { const d = await r.json(); setItems(d.inquiries || []); } }
    catch (e) { console.error(e); } finally { setLoading(false); }
  }

  async function markContacted(id) {
    await authFetch(`${API}/admin/ad-inquiries/${id}`, { method: 'PUT', body: JSON.stringify({ status: 'contacted' }) });
    toast.success('Označeno kao kontaktirano'); load();
  }

  async function archive(id) {
    await authFetch(`${API}/admin/ad-inquiries/${id}`, { method: 'PUT', body: JSON.stringify({ status: 'archived' }) });
    toast.success('Arhivirano'); load();
  }

  if (loading) return <div className="flex items-center justify-center h-full"><Loader2 className="animate-spin text-zinc-500" /></div>;

  return (
    <div className="p-6 max-w-6xl" data-testid="ad-inquiries-page">
      <h1 className="text-2xl font-semibold mb-6">Upiti za oglašavanje</h1>
      {items.length === 0 ? (
        <div className="text-center py-12 text-zinc-500">Nema upita</div>
      ) : (
        <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-zinc-800 text-zinc-500 text-left">
              <th className="px-4 py-3 font-medium">Datum</th>
              <th className="px-4 py-3 font-medium">Ime</th>
              <th className="px-4 py-3 font-medium">Tvrtka</th>
              <th className="px-4 py-3 font-medium">Budžet</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium w-28">Akcije</th>
            </tr></thead>
            <tbody>
              {items.map(q => (
                <tr key={q.id} className="border-b border-zinc-800/50 hover:bg-zinc-800/30">
                  <td className="px-4 py-3 text-zinc-400 text-xs">{new Date(q.created_at).toLocaleDateString('hr')}</td>
                  <td className="px-4 py-3 text-zinc-200">{q.name}<br /><span className="text-xs text-zinc-500">{q.email}</span></td>
                  <td className="px-4 py-3 text-zinc-400">{q.company || '\u2014'}</td>
                  <td className="px-4 py-3 text-zinc-400">{q.budget || '\u2014'}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-1.5 py-0.5 rounded ${q.status === 'contacted' ? 'bg-blue-500/20 text-blue-400' : q.status === 'archived' ? 'bg-zinc-700 text-zinc-400' : 'bg-amber-500/20 text-amber-400'}`}>{q.status}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex gap-1">
                      {q.status === 'new' && <button onClick={() => markContacted(q.id)} className="p-1.5 text-zinc-500 hover:text-blue-400" title="Kontaktirano"><Phone size={14} /></button>}
                      {q.status !== 'archived' && <button onClick={() => archive(q.id)} className="p-1.5 text-zinc-500 hover:text-zinc-300" title="Arhiviraj"><Archive size={14} /></button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
